import { FC, useCallback } from 'react';
import { useField, useForm } from 'react-final-form';

import { ProgressButton } from '@beeline/design-system-react/extracted-styles';

import { Panel } from 'src/components/Panel/Panel';
import { removeFloor } from 'src/store/floors/services';
import { useAppDispatch } from 'src/store/useAppDispatch';

import { AdministratorFloorFields } from '../AdministratorFloorForm/AdministratorFloorFields';
import { AdministratorFloorForm } from '../AdministratorFloorForm/AdministratorFloorForm';

const Actions: FC = () => {
  const id = useField<number | undefined>('id').input.value;
  const dispatch = useAppDispatch();

  const { submit } = useForm();

  const saveFloor = useCallback(async () => {
    const result = await submit();
    if (!result) throw new Error('Form is invalid');
  }, [submit]);

  const deleteFloor = useCallback(async () => {
    if (id) await dispatch(removeFloor(id));
  }, [dispatch, id]);

  return (
    <>
      {id && (
        <ProgressButton
          variant='outlined'
          onClick={deleteFloor}
          data-testid='deleteFloor'
        >
          Удалить
        </ProgressButton>
      )}
      <ProgressButton
        variant='contained'
        onClick={saveFloor}
        data-testid='saveFloor'
        type='submit'
      >
        {id ? 'Сохранить' : 'Создать'}
      </ProgressButton>
    </>
  );
};

export const AdministratorFloorSidesheetPanel: FC = () => {
  return (
    <AdministratorFloorForm>
      <Panel actions={<Actions />} testId='administratorFloorSidesheetPanel'>
        <AdministratorFloorFields />
      </Panel>
    </AdministratorFloorForm>
  );
};
